import React, { useEffect, useState } from 'react';

import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

import { apiKeyGMap, defaultCoords, geocodeAddress } from './utils';

type Props = {
  className?: string;
  coordinates?: { lat: number; lng: number };
  address?: string;
  zoom?: number;
  height?: string;
};

const Map: React.FC<Props> = ({
  className = '',
  coordinates,
  address,
  zoom = 14,
  height = '500px',
}) => {
  const [center, setCenter] = useState(coordinates || defaultCoords);

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: apiKeyGMap,
    libraries: ['places'],
  });

  useEffect(() => {
    if (!coordinates && address && isLoaded) {
      geocodeAddress(address)
        .then((coords) => {
          if (coords) setCenter(coords);
          else console.warn('[Map] Geocode returned null');
        })
        .catch((err) => {
          console.error('[Map] Geocode error:', err);
        });
    }
  }, [isLoaded, address, coordinates]);

  if (loadError) {
    return <div className={className}>Failed to load Google Maps API.</div>;
  }

  if (!isLoaded) {
    return <div className={className}>Loading map...</div>;
  }

  return (
    <div className={className} style={{ height }}>
      <GoogleMap mapContainerStyle={{ width: '100%', height: '100%' }} center={center} zoom={zoom}>
        <Marker position={center} />
      </GoogleMap>
    </div>
  );
};

export default Map;
